import { render, staticRenderFns } from "./PageXieYi.vue?vue&type=template&id=547bddb8&scoped=true&"
import script from "./PageXieYi.vue?vue&type=script&lang=js&"
export * from "./PageXieYi.vue?vue&type=script&lang=js&"
import style0 from "./PageXieYi.vue?vue&type=style&index=0&id=547bddb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547bddb8",
  null
  
)

export default component.exports